<div class="header">
    <h2>{{ 'quizzes.questions.dialog.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="dialog-add-question-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<div class="body">
    <div class="toggle">
        <p-button
            [label]="'quizzes.questions.dialog.select' | translate"
            [outlined]="mode() !== 'select'"
            data-test="dialog-add-question-mode-select"
            (onClick)="setMode('select')"
        />
        <p-button
            [label]="'quizzes.questions.dialog.create' | translate"
            [outlined]="mode() !== 'create'"
            data-test="dialog-add-question-mode-create"
            (onClick)="setMode('create')"
        />
    </div>

    @if (mode() === 'select') {
        <app-dialog-search [placeholder]="searchPlaceholder" testId="dialog-add-question-search" (searchChange)="onSearch($event)" />

        <div class="list-container">
            @if (listLoading()) {
                <div class="list-loading"><i class="pi pi-spin pi-spinner"></i></div>
            }
            @if (quizQuestions().length === 0 && !listLoading()) {
                <p class="empty">{{ 'quizzes.questions.dialog.select.empty' | translate }}</p>
            } @else {
                <div class="list">
                    @for (question of quizQuestions(); track question.id) {
                        <button class="item" [attr.data-test]="'dialog-add-question-item-' + question.id" (click)="selectQuestion(question)">
                            <div class="icon">
                                <i class="pi pi-question-circle"></i>
                            </div>
                            <span class="name">{{ question.questionText }}</span>
                            <span class="count">{{ question.answers.length }}</span>
                        </button>
                    }
                </div>
            }
        </div>
        <p-paginator [rows]="limit" [totalRecords]="total()" [first]="first()" (onPageChange)="onPageChange($event)" />
    } @else {
        <form [formGroup]="form" (ngSubmit)="onCreateSubmit()">
            <div class="create-form">
                <app-form-input
                    [control]="form.controls.questionText"
                    [label]="'quiz-questions.form.questionText' | translate"
                    [placeholder]="'quiz-questions.form.questionText.placeholder' | translate"
                    inputId="dialogQuestionText"
                    testId="dialog-add-question-question-text"
                />

                <h3>{{ 'quiz-questions.fieldset.answers' | translate }}</h3>

                <div formArrayName="answers">
                    @for (answer of answers.controls; track $index) {
                        <app-quiz-answer
                            [formGroupName]="$index"
                            [control]="answer"
                            [index]="$index"
                            [correctAnswer]="correctAnswer"
                            [canRemove]="answers.length > 1"
                            [testId]="'quiz-questions-answer-' + $index"
                            (remove)="removeAnswer($index)"
                        />
                    }
                </div>

                <p-button
                    [label]="'quiz-questions.form.answer.add' | translate"
                    icon="pi pi-plus"
                    [outlined]="true"
                    severity="secondary"
                    data-test="dialog-add-question-answer-add"
                    (onClick)="addAnswer()"
                />
            </div>

            <div class="actions">
                <p-button
                    type="submit"
                    [label]="'quiz-questions.form.create' | translate"
                    [loading]="creating()"
                    [disabled]="form.disabled"
                    data-test="dialog-add-question-submit"
                />
            </div>
        </form>
    }
</div>
